// client/src/services/api.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 120000, // 2분 타임아웃 (큰 이미지 업로드 대비)
});

// NFT 등록
export const registerNFT = async (formData) => {
  try {
    console.log('NFT 등록 요청 시작...');
    
    // FormData 내용 로깅 (디버깅용)
    for (let pair of formData.entries()) {
      if (pair[1] instanceof File) {
        console.log(`${pair[0]}: File(${pair[1].name}, ${(pair[1].size / 1024 / 1024).toFixed(2)}MB)`);
      } else {
        console.log(`${pair[0]}: ${pair[1]}`);
      }
    }
    
    const response = await axios.post(`${API_URL}/nft/register`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 120000,
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        console.log(`업로드 진행률: ${percentCompleted}%`);
      }
    });
    
    console.log('NFT 등록 성공:', response.data);
    return response.data;
  } catch (error) {
    console.error('NFT 등록 오류:', error);
    
    if (error.code === 'ECONNABORTED') {
      throw { error: '업로드 시간이 초과되었습니다. 이미지 크기를 줄여주세요.' };
    }
    
    if (error.response) {
      console.error('서버 응답 오류:', error.response.data);
      throw error.response.data;
    }
    
    if (error.request) {
      console.error('네트워크 오류:', error.request);
      throw { error: '서버에 연결할 수 없습니다. 네트워크를 확인해주세요.' };
    }
    
    throw { error: error.message || '알 수 없는 오류가 발생했습니다.' };
  }
};

// NFT 수정
export const updateNFT = async (id, formData) => {
  try {
    console.log(`NFT 수정 요청 시작 (ID: ${id})...`);
    
    const response = await axios.put(`${API_URL}/nft/update/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 120000,
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        console.log(`업로드 진행률: ${percentCompleted}%`);
      }
    });
    
    console.log('NFT 수정 성공:', response.data);
    return response.data;
  } catch (error) {
    console.error('NFT 수정 오류:', error);
    
    if (error.code === 'ECONNABORTED') {
      throw { error: '업로드 시간이 초과되었습니다.' };
    }
    
    throw error.response?.data || { error: '네트워크 오류가 발생했습니다.' };
  }
};

// 컬렉션 목록 조회
export const getCollections = async () => {
  try {
    const response = await api.get('/collections');
    return response.data;
  } catch (error) {
    console.error('컬렉션 목록 조회 오류:', error);
    throw error.response?.data || { error: '네트워크 오류가 발생했습니다.' };
  }
};

// 컬렉션별 NFT 목록 조회
export const getNFTList = async (collectionName) => {
  try {
    const response = await api.get(`/nft/list/${encodeURIComponent(collectionName)}`);
    return response.data;
  } catch (error) {
    console.error('NFT 목록 조회 오류:', error);
    throw error.response?.data || { error: '네트워크 오류가 발생했습니다.' };
  }
};

// NFT 상세 조회
export const getNFTDetail = async (id) => {
  try {
    const response = await api.get(`/nft/detail/${id}`);
    return response.data;
  } catch (error) {
    console.error('NFT 상세 조회 오류:', error);
    throw error.response?.data || { error: '네트워크 오류가 발생했습니다.' };
  }
};

// 이미지 URL 생성 (개선된 버전)
export const getImageUrl = (uri) => {
  if (!uri) {
    console.warn('getImageUrl: URI가 없습니다.');
    return null;
  }
  
  // 이미 전체 URL인 경우
  if (uri.startsWith('http://') || uri.startsWith('https://')) {
    console.log('이미지 URL (전체 URL):', uri);
    return uri;
  }
  
  // API_URL에서 /api 제거하여 기본 서버 URL만 사용
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3002/api';
  const baseURL = apiUrl.replace('/api', '');
  
  // URI가 /로 시작하지 않으면 추가
  const normalizedUri = uri.startsWith('/') ? uri : `/${uri}`;
  
  const fullUrl = `${baseURL}${normalizedUri}`;
  console.log('🖼️ 이미지 URL 생성:');
  console.log('   - URI:', uri);
  console.log('   - Base URL:', baseURL);
  console.log('   - Full URL:', fullUrl);
  
  return fullUrl;
};

export default api;